import { Component, type ErrorInfo, type ReactNode } from 'react';
import { logConsentEvent } from '../../log';

type Props = {
  /** The children to render. */
  children: ReactNode;
  /** Which consent surface this boundary wraps, for the crash log. */
  surface: 'banner' | 'dialog';
};

type State = {
  hasError: boolean;
};

export class ConsentErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logConsentEvent('ui.crashed', {
      surface: this.props.surface,
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
